import T from '../../services/language';
import {useApp} from "../../contexts/app";
import {
    CloseIcon,
    InputLabel,
    InputView,
    ModalContent,
    ModalContentBody,
    ModalContentFooter,
    ModalContentFooterSubmit,
    ModalContentHead,
    ModalContentHeadDesc,
    ModalContentHeadTitle
} from "./style";
import {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {postGroupExcute, preloadQuestionAndAnswer} from "../../services/app";
import {message} from "antd";

export default function Verify(props: any) {
    const {visible} = props;
    const {campaign, customer, groupSlug, shareUrlKey, setCampaign, setCustomer, clientCode} = useApp();
    const [code, setCode] = useState("");
    const [ready, setReady] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const codeQuery = searchParams.get('accessCode');
    const canVerify = !(campaign && (!campaign?.isRequireAccessCode || !!codeQuery));

    useEffect(() => {
        if (visible) {
            if (!canVerify) {
                onSubmit().then();
            } else {
                setReady(true);
            }
        }
    }, [campaign?.shareUrlKey, visible])

    const onSubmit = async () => {
        props?.onLoading(true);
        setLoading(true);
        const result = await postGroupExcute({
            // Two-segment URL is required — backend re-verifies that
            // slugify(group.name) === groupSlug AND group.shareUrlKey ===
            // shareUrlKey, so a crafted request with just a shareUrlKey
            // gets rejected.
            "groupSlug": groupSlug,
            "shareUrlKey": shareUrlKey,
            "code": code || codeQuery || undefined
        });
        if (result.status === 200) {
            const data = result.data.data || {};
            setCampaign({campaignId: data.campaignId, ...campaign});
            setCustomer({...data, code: (code || codeQuery)});

            if (data?.campaignId && data?.customerId) {
                preloadQuestionAndAnswer(data.campaignId, data.customerId).then(res => console.log(`preloadQuestionAndAnswer`, res));
            }

            // Downstream booking-flow URL: /:groupSlug/:shareUrlKey/:campaignId/:customerId/...
            // For group URLs we pass pssGroupId in the :campaignId slot —
            // downstream APIs accept either. Keeping both segments at the
            // front means a mid-flow refresh still re-resolves the group
            // cleanly (no need to cache the shareUrlKey separately).
            const catalogId = data?.isGroupUrl ? data?.pssGroupId : data?.campaignId;

            if (data?.activeServices?.length === 1) {
                const serviceId = data?.activeServices[0];
                // auto next with one service
                props.onClose(`/${groupSlug}/${shareUrlKey}/${catalogId}/${data.customerId}/product-and-service/${data.type}/${serviceId}/none/`)
            } else {
                props.onClose(`/${groupSlug}/${shareUrlKey}/${catalogId}/${data.customerId}/product-and-service/${data.type}/`)
            }
        } else {
            message.error(result?.data?.message || T("Error request!"))
        }
        setReady(true);
        props?.onLoading(false);
        setLoading(false);
    }

    return (ready && canVerify) ? (
        <ModalContent>
            <ModalContentHead>
                <CloseIcon onClick={() => props.onClose(false)}/>
                <ModalContentHeadTitle>{T('Verification')}</ModalContentHeadTitle>
            </ModalContentHead>
            <ModalContentBody style={{height: 'auto'}}>
                <ModalContentHeadDesc>{T('Please key in the access code given to you')}</ModalContentHeadDesc>
                <div>
                    <InputLabel>{T('Access code')}</InputLabel>
                    <InputView value={code} onChange={event => setCode(event.target.value)}/>
                </div>
            </ModalContentBody>
            <ModalContentFooter style={{justifyContent: 'center', marginTop: 6}}>
                <ModalContentFooterSubmit loading={loading} style={{width: 200}} disabled={!code}
                                          onClick={onSubmit}>{T('Start')}</ModalContentFooterSubmit>
            </ModalContentFooter>
        </ModalContent>
    ) : null;
}